import { select, takeLeading } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { SearchQuery } from 'containers/ExpertHomePage/typings';
import { setFoundMissions } from 'containers/ExpertHomePage/actions';
import { REQUEST_SEARCH_MISSIONS } from 'containers/ExpertHomePage/constants';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import accessTokenStorage from 'containers/services/security/access-token-storage';

export interface ISearchAction {
  type: string;
  searchQuery: SearchQuery;
}

export function* findMissions(action: ISearchAction): Generator<unknown> {
  const path = '/corporeal/common/search-mission';
  const intervenantToken = yield select(makeSelectKeycloakToken());
  const token = !intervenantToken
    ? accessTokenStorage.get().token
    : intervenantToken;
  if (!token) return;
  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(action.searchQuery),
  };
  yield callApi(path, {}, options, [], setFoundMissions);
}

export function* requestFindMisssionsSaga() {
  yield takeLeading(REQUEST_SEARCH_MISSIONS, findMissions);
}

export default [requestFindMisssionsSaga];
